
<template>
  <!--推送通知-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="pushId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <span slot="iOS"><a-icon type="smile-o"/>目标 | 成功</span>
      <span slot="Android"><a-icon type="smile-o"/>目标 | 成功</span>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'push',
  data () {
    return {
      searchList: [
        { props: ['title'], placeholder: '推送标题', inputType: 'input' },
        { props: ['pushOs'], placeholder: '目标平台', options: [], inputType: 'select' },
        { props: ['pushApp'], placeholder: '应用', options: [], inputType: 'select' },
        { props: ['scopeType'], placeholder: '用户范围', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.pushStatusList, inputType: 'select' },
        { props: ['createDate'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:push:add'] }
      ],
      rowOptList: [
        { text: '详情', handle: (row) => this.toDetail(row.pushId), permi: ['community:push:query'] },
        {
          text: '撤回',
          handle: (row) => this.cancel(row.pushId),
          rowOptDisHandle: row => row.status !== 0,
          permi: ['community:push:remove']
        }
      ],
      columns: [
        { title: '推送时间', dataIndex: 'sendTime', align: 'left', width: '' },
        { title: '推送标题', dataIndex: 'title', align: 'left', width: '' },
        { title: '应用', dataIndex: 'pushAppDesc', align: 'left', width: '' },
        { title: '用户范围', dataIndex: 'scopeType', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        // { title: '目标 | 成功', dataIndex: 'ios_total', align: 'left', width: '', slots: {title: 'iOS'} },
        // { title: '目标 | 成功', dataIndex: 'android_total', align: 'left', width: '', slots: {title: 'Android'} },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        title: '',
        pushOs: '',
        pushApp: '',
        scopeType: '',
        status: '',
        createDate: ''
      },
      listApi: {
        url: '/push/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addPush',
        addTitle: '新增推送'
      },
      deleteParam: {}
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      // let paramArr = [
      //   { index: 1, query: 'push_aims_type_desc', scope: 'searchList' },
      //   { index: 2, query: 'message_aims_type_desc', scope: 'searchList' },
      //   { index: 3, query: 'scope_type_desc', scope: 'searchList' }
      // ];
      // paramArr.forEach((el) => {
      //   this.typeSelect(el);
      // });
      let paramArr = [
        {index: 1, scope: 'searchList', query: 'comu_application_platform'},
        {index: 2, scope: 'searchList', query: 'comu_msg_aims'},
        {index: 3, scope: 'searchList', query: 'comu_msg_scope_type'}
      ];
      this.dictionarySelect(paramArr);
    },
    /* 进入详情页面 */
    toDetail (id) {
      this.$router.push({
        name: 'pushDetail',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    /* 撤销推送 */
    cancel (id) {
      this.$confirm({
        title: '确定要撤回该条推送？',
        centered: true,
        onOk: (close) => {
          close();
          this.$put({
            url: `/push/cancel/${id}`,
            params: {}
          }).then((res) => {
            this.$message.success('撤回成功！');
            this.$refs.table.getTableList();
          });
        }
      });
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>
